// 9fbef606107a605d69c0edbcd8029e5d
import styled, { keyframes } from 'styled-components';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';

const scroll = keyframes`
  to {
    transform: translateX(calc(-50% - 0.5rem));
  }
`;

export const Scroller = styled.div`
  width: 100%;
  overflow: hidden;
`;

export const ScrollerInner = styled.ul`
  display: flex;
  width: max-content;
  flex-wrap: nowrap;
  animation: ${scroll} ${(props) => `${props.speed}s`} linear infinite
    ${(props) => (props.direction === 'right' ? 'reverse' : 'forwards')};
  will-change: transform;
  animation-play-state: running;

  &:hover,
  &:focus {
    animation-play-state: paused;
  }
`;

export const ColorSlider = styled.li`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  ${(props) => (props.colorData ? `background-color: ${props.colorData.color};` : '')}
`;

export const Slide = styled(Anchor)`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS}
    ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
  .slider-content-innerText p > span:not(:first-child) {
    padding-left: 10px;
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    padding-bottom: 4px;
  }
`;

export const ImageSlider = styled.li`
  position: relative;
  text-align: center;

  .module-slider-marquee-image-link {
    padding: 0;
  }
  .slider-content-innerText {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
  }
`;

export const ImageTag = styled(Image)`
  width: 100vw;
`;
